import { SectionHead } from "./SectionHead";

const GROUPS = ["CEOs and board members", "Investors and owners", "Founders and builders", "Technology leaders", "Public-sector leaders", "Researchers and policymakers"];

const STANDARD = [
  ["No sales pitches on stage", "Every session is prepared, briefed and moderated by the summit. Partners speak for themselves — and earn the room, not buy it."],
  ["Invitation-led", "700 seats, curated across leadership, technology, capital and policy. Not a ticket you buy — a seat you are given."],
  ["One room, one programme", "No parallel tracks. Everyone hears the same argument, sees the same build and leaves with the same references."],
  ["Closed rooms, real conversations", "The Executive Room and the Board Briefing run under the Chatham House Rule. No press, no recording, no pitch."],
];

const Dots = () => {
  const cols = 28, rows = 25, gap = 20, dots = [];
  for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) {
    dots.push(<circle key={`${i}-${j}`} cx={i * gap + 3} cy={j * gap + 3} r="2.6" style={{ animationDelay: `${0.2 + j * 0.028 + i * 0.006}s` }} />);
  }
  return (
    <svg className="ns-dots" viewBox={`0 0 ${(cols - 1) * gap + 6} ${(rows - 1) * gap + 6}`} fill="currentColor" aria-hidden data-rv="dots" data-testid="ns-room-dots">
      {dots}
    </svg>
  );
};

export const TheRoom = () => (
  <section className="ns-sec ns-room" id="room" data-testid="ns-room">
    <div className="ns-wrap">
      <SectionHead nr="03" label="The room" right="700 seats · invitation-led" />
      <div className="ns-grid">
        <div className="g-1-6">
          <div className="ns-big" data-rv data-testid="ns-room-700">700</div>
          <p className="ns-lede mt" data-rv style={{ "--d": ".1s" }} data-testid="ns-room-sub">Seats. Curated for the people deciding how AI is built, bought and governed.</p>
          <p className="ns-p mt" data-rv style={{ "--d": ".2s" }} data-testid="ns-room-line">Invitation-led · One room, one programme · Grieghallen, Bergen · 13 April 2027</p>
        </div>
        <div className="g-8-12">
          <Dots />
          <p className="ns-p mt-s" data-rv style={{ "--d": ".6s" }} data-testid="ns-room-cap">One dot per seat. <b>700</b> — not 7,000. The room is the product.</p>
        </div>
        <div className="g-1-5">
          <h3 className="ns-h3" data-rv>Who is in the room</h3>
          <ul className="ns-groups" data-rv style={{ "--d": ".1s" }} data-testid="ns-room-groups">
            {GROUPS.map((g) => <li key={g}>{g}</li>)}
          </ul>
        </div>
        <div className="g-7-12">
          <h3 className="ns-h3" data-rv>Not another conference. A standard for the room.</h3>
          <ul className="ns-ledger two" data-rv style={{ "--d": ".1s" }} data-testid="ns-room-standard">
            {STANDARD.map(([t, d]) => <li key={t}><span className="t">{t}</span><span className="d">{d}</span></li>)}
          </ul>
        </div>
      </div>
    </div>
  </section>
);
